import { axios, API, SendRequest} from '@/imports-files/pages/clients/communication/index';
import { STATIC_DATA } from 'public/JSON_DATA/communication_center/sent-message';
        
export class CommunicationService extends SendRequest 
{

  async getCommunicationData(params) 
  {
    // TODO :-  remove the static code for the sent item as the send item is not working
    
    // if(params.email_type == 'sent')
    // {
    //   return STATIC_DATA;
    // }
    // else
    // {
    const url = API.client.communication.COMMUNICATION_DATA;
     try {
            const result = await axios.get( url,
              {
                  params: params,
                  headers: this.customHeaderJSON()
              },
              this.setHeaderJSON(),
              this.setCrossDomainTrue(),
              this.setCredentialsJSON());

            return result;
          } 
          catch (error)
          {
            return error;
          }
    // }
  }

}